import React from "react";
import MotorForm from "../components/forms/MotorForm";
import BikeForm from "../components/forms/BikeForm";
import HealthForm from "../components/forms/HealthForm";
//import TravelForm from "../components/forms/TravelForm";

import FlatInsuranceForm from "../components/forms/FlatInsuranceForm";



import MotorLiabilityForm from "../components/forms/MotorLiabilityForm";

import TpForm from "../components/forms/TpForm";

import { AppBar, Toolbar, Typography, Container, Box } from "@mui/material";

const ProductInputPage = ({ product, onAddToCart, onBack }) => {
  const renderForm = () => {
    switch (product.type) {
      case "car":
        return <MotorForm onSubmit={onAddToCart} productType="Motor Insurance" />;
      case "bike":
        return <BikeForm onSubmit={onAddToCart} productType="Bike Insurance" />;
      case "al":
        return <MotorLiabilityForm onSubmit={onAddToCart} productType="Commercial Vehicle Insurance" />;
      case "property":
        return <FlatInsuranceForm onSubmit={onAddToCart} productType="FlatInsurance" />;
      case "overseas_mediclaim":
        return <HealthForm onSubmit={onAddToCart} productType="Travel Insurance" />;
      case "tp":
        return <TpForm onSubmit={onAddToCart} productType="Third Party Insurance" />;
      default:
        return <p>This product will be available soon</p>;
    }
  };

  return (
    <div>
         <AppBar position="static">
        <Toolbar sx={{ justifyContent: "center" }}>
          <a href="/" style={{ display: "flex", alignItems: "center", textDecoration: "none", color: "inherit" }}>
            <img
              src="/logo192.png"
              alt="BGIC Logo"
              style={{ height: 50, marginRight: 16 }}
            />
            <Typography variant="h6" component="div">
              BGIC Digital Store
            </Typography>
          </a>
        </Toolbar>
      </AppBar>
    <div style={{ padding: "20px", maxWidth: "800px", margin: "0 auto" }}>
      {/* Back button */}
      <button
        onClick={onBack}
        style={{
          marginBottom: "20px",
          padding: "8px 15px",
          background: "#6c757d",
          color: "#fff",
          border: "none",
          borderRadius: "5px",
          cursor: "pointer",
        }}
      >
        ← Back
      </button>

      {/* Title */}
      {/* <h2 style={{ marginBottom: "20px" }}>{product.name}</h2>

      <p
  style={{
    marginBottom: "15px",
    fontSize: "14px",
    color: "#555",
    fontWeight: 500,
  }}
>
  Please tap below to fill in the required information.
</p> */ }

      {/* Render Selected Form */}
      <div
        style={{
          padding: "20px",
          border: "1px solid #ddd",
          borderRadius: "10px",
          boxShadow: "0 4px 6px rgba(0,0,0,0.05)",
          backgroundColor: "#fafafa",
        }}
      >
        {renderForm()}
      </div>
    </div>
    </div>
  );
};

export default ProductInputPage;
